import module from 'usuario/module.js'

let schema = {
  activo: 'boolean',
  vinculo: 'boolean',
  master: 'boolean',
  enviar_invitacion:'boolean',
  invitacion_activa: 'boolean',
  duracion: 'number',
  departamento_id: 'number',
  puesto_id: 'number',
  id: 'number',
}

export class UsuarioService {
  constructor ($http) {
    this.$http = $http
  }

  get (usuario_id) {
    return this.$http.get('/api/usuario', {
      params: {usuario_id},
      schema,
    })
  }

  put (data, usuario_id) {
    return this.$http.put('/api/usuario', data, {
      params: {usuario_id},
      schema
    })
  }
}
module.service('Usuario', UsuarioService)



// WEBPACK FOOTER //
// ./src/usuario/services/Usuario.js